module.exports = __webpack_public_path__ + "static/img/cont3006.9aa5370.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3006.jpg
// module id = ntlS
// module chunks = 0